import store from '@/store/store';

export default function (to, from, next) {
    if (store.getters['Account/appearsLoggedIn']) {
        next({name: 'app.dashboard'});
    } else {
        next();
    }
}
